import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'Components/Molecules/Dialog/Dialog';
import ItemSelector from 'Components/Molecules/ItemSelector/ItemSelector';
import workspaceIcon from 'assets/workspace-icon.svg';
import Loading from 'Components/Atoms/Loading/Loading';
import useProjects from 'Hooks/useProjects';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import Button from 'Components/Atoms/Button/Button';
import ChangeWorkspaceJoinProjectForm from './ChangeWorkspaceJoinProjectForm';
import { useTranslation } from 'react-i18next';

export default function ChangeWorkspaceSelectProjectDialog(props) {
    const { open, onClose, onSelect } = props;
    const { projects, isLoading } = useProjects();
    const [showJoinProject, setShowJoinProject] = useState(false);

    const { user } = useUser();
    const { t } = useTranslation('common');

    useEffect(() => {
        if (open) {
            setShowJoinProject(false);
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} size="sm" zIndex="var(--z-index-popover)">
            {!showJoinProject && (
                <div className="p-2 sm:p-6">
                    <div className="text-center mb-4">
                        <h4>{t('select-workspace.projects-title')}</h4>
                        <div className="text-gray-500 pb-2">{t('select-workspace.projects-description')}</div>
                    </div>

                    {user.is_support && (
                        <div className="text-center mb-4" style={{ marginTop: -12 }}>
                            <Button variant="primary" size="small" onClick={() => setShowJoinProject(true)}>
                                {t('select-workspace.join-project')}
                            </Button>
                        </div>
                    )}

                    {isLoading && (
                        <div className="py-6">
                            <Loading message={t('select-workspace.projects-loading')} />
                        </div>
                    )}

                    {!isLoading && (
                        <div
                            className="grid gap-4"
                            style={{
                                overflow: 'auto',
                                maxHeight: 'calc(100dvh - 320px)',
                                padding: 8,
                                marginLeft: -8,
                                marginRight: -8,
                            }}
                        >
                            {projects.map((project) => (
                                <ItemSelector
                                    key={project.id}
                                    image={workspaceIcon}
                                    title={project.name}
                                    ellipsis
                                    onClick={() => onSelect(project)}
                                />
                            ))}
                        </div>
                    )}
                </div>
            )}

            {showJoinProject && (
                <>
                    <div className="text-center mb-6">
                        <h4>{t('select-workspace.join-project')}</h4>
                        <div className="text-gray-500 pb-2">{t('select-workspace.join-project-description')}</div>
                    </div>
                    <ChangeWorkspaceJoinProjectForm
                        onComplete={(joinedProject) => {
                            setShowJoinProject(false);

                            if (joinedProject) {
                                onSelect(joinedProject);
                            }
                        }}
                    />
                </>
            )}
        </Dialog>
    );
}

ChangeWorkspaceSelectProjectDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};
